import { ELIGIBILITY_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const eligibilityBuilderSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ELIGIBILITY_CRITERIA_ACTION_TYPE.GET_ELIGIBILITY_CRITERIA_SCHEMA:
      return payload || initialState;

    default:
      return state;
  }
};

export default eligibilityBuilderSchemaReducer;
